import { defineMessages } from 'react-intl';

export const messages: {
	youLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultAssistantName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCypherButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	youLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatMessage.youLabel.non-final',
		defaultMessage: 'You',
		description: 'Label shown above a user message in the chat conversation.',
	},
	defaultAssistantName: {
		id: 'dtac.graphExplorer.cyphieChat.chatMessage.defaultAssistantName.non-final',
		defaultMessage: 'Assistant',
		description: 'Default name shown above an assistant message in the chat conversation.',
	},
	useCypherButton: {
		id: 'dtac.graphExplorer.cyphieChat.chatMessage.useCypherButton.non-final',
		defaultMessage: 'Use cypher',
		description: 'Button label to apply the generated Cypher query to the query editor.',
	},
});
